import {
  GoogleMap,
  Marker,
  InfoWindow,
  useJsApiLoader,
  DirectionsRenderer,
} from "@react-google-maps/api";
import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Spinner from "../../components/Spinner";

const containerStyle = {
  width: "100%",
  height: "100%",
};

const statusMap = {
  AVAILABLE: "متاح",
  ONLINE: "اونلاين",
  IN_TRIP: "في الرحلة",
};

const defaultCenter = {
  lat: 24.7136,
  lng: 46.6753,
};

const MapContainer = styled.div`
  background-color: white;
  padding: 1rem;
  border-radius: 7px;
  width: 55%;
  height: 82vh;
  box-shadow: 3px 3px 10px rgba(40, 40, 40, 0.1);

  @media (max-width: 992px) {
    width: 100%;
    height: 50vh; /* reduce height on mobile */
  }
`;
const Map = ({ drivers = [], selectedDriver, setSelectedDriver }) => {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  });

  const [hoveredRoute, setHoveredRoute] = useState(null);
  const [directions, setDirections] = useState(null);
  const [hoveredDriver, setHoveredDriver] = useState(null);
  const [map, setMap] = useState(null);
  useEffect(() => {
    if (selectedDriver && map) {
      const trip = selectedDriver.trip?.[0];
      const location =
        Array.isArray(trip?.current_location) &&
        trip.current_location.length === 2
          ? trip.current_location
          : selectedDriver.location;

      if (Array.isArray(location) && location.length === 2) {
        map.panTo({
          lat: parseFloat(location[0]),
          lng: parseFloat(location[1]),
        });
        map.setZoom(14);
      }
    }
  }, [selectedDriver, map]);

  useEffect(() => {
    if (hoveredRoute) {
      const directionsService = new window.google.maps.DirectionsService();
      directionsService.route(
        {
          origin: hoveredRoute.origin,
          destination: hoveredRoute.destination,
          travelMode: window.google.maps.TravelMode.DRIVING,
        },
        (result, status) => {
          if (status === window.google.maps.DirectionsStatus.OK) {
            setDirections(result);
          } else {
            console.error("Directions request failed due to", status);
          }
        }
      );
    } else {
      setDirections(null);
    }
  }, [hoveredRoute]);

  if (!isLoaded) return <Spinner />;

  const driversWithLocation = drivers.filter(
    (driver) =>
      Array.isArray(driver.location) &&
      driver.location.length === 2 &&
      !isNaN(driver.location[0]) &&
      !isNaN(driver.location[1])
  );

  return (
    <MapContainer>
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={defaultCenter}
        zoom={10}
        onLoad={(mapInstance) => setMap(mapInstance)}
        onClick={() => setSelectedDriver(null)}
      >
        {driversWithLocation.map((driver) => {
          const isInTrip = driver.availability === "IN_TRIP";
          const trip = driver.trip?.[0];

          const markerPosition = {
            lat: parseFloat(
              Array.isArray(trip?.current_location) &&
                trip.current_location.length === 2
                ? trip.current_location[0]
                : driver.location[0]
            ),
            lng: parseFloat(
              Array.isArray(trip?.current_location) &&
                trip.current_location.length === 2
                ? trip.current_location[1]
                : driver.location[1]
            ),
          };

          const isSelected = selectedDriver?._id === driver._id;

          return (
            <React.Fragment key={driver._id}>
              <Marker
                position={markerPosition}
                icon={{
                  url: isSelected
                    ? "https://maps.google.com/mapfiles/ms/icons/green-dot.png"
                    : "https://maps.google.com/mapfiles/kml/shapes/cabs.png",
                  scaledSize: new window.google.maps.Size(40, 40),
                }}
                onMouseOver={() => {
                  setHoveredDriver({ driver, position: markerPosition });

                  if (
                    isInTrip &&
                    Array.isArray(trip?.current_location) &&
                    trip.current_location.length === 2 &&
                    Array.isArray(trip?.dropoff_location) &&
                    trip.dropoff_location.length === 2
                  ) {
                    setHoveredRoute({
                      origin: {
                        lat: trip.current_location[0],
                        lng: trip.current_location[1],
                      },
                      destination: {
                        lat: trip.dropoff_location[0],
                        lng: trip.dropoff_location[1],
                      },
                    });
                  }
                }}
                onMouseOut={() => {
                  setHoveredDriver(null);
                  setHoveredRoute(null);
                }}
                onClick={() => setSelectedDriver(driver)}
              />

              {hoveredDriver?.driver._id === driver._id && (
                <InfoWindow
                  position={markerPosition}
                  options={{ pixelOffset: new window.google.maps.Size(0, -40) }}
                >
                  <div
                    style={{
                      fontFamily: "Noto Kufi Arabic, sans-serif",
                      textAlign: "center",
                      padding: "8px 8px",
                      backgroundColor: "#fff",
                      borderRadius: "8px",
                      minWidth: "90px",
                      fontSize: "16px",
                      direction: "rtl",
                    }}
                  >
                    <strong>{driver.user.name}</strong>
                    <div style={{ color: "#666", marginTop: "6px" }}>
                      {statusMap[driver.availability] || "غير معروف"}
                    </div>
                  </div>
                </InfoWindow>
              )}
            </React.Fragment>
          );
        })}

        {directions && (
          <DirectionsRenderer
            directions={directions}
            options={{
              suppressMarkers: true,
              polylineOptions: {
                strokeColor: "#0a5c56",
                strokeWeight: 5,
              },
            }}
          />
        )}
      </GoogleMap>
    </MapContainer>
  );
};

export default Map;
